// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import { useAuth } from './context/AuthContext'; // Importe o hook useAuth
import PDV from './pages/PDV';

function App() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div>Carregando...</div>; // ou spinner bonito
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/PDV"
          element={isAuthenticated ? <PDV /> : <Navigate to="/login" />}
        />

        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );

}

export default App;
